import Tutorial from './Tutorial';
import common from '../../common';
import {translate} from '../../utils';
import MorphCommand from '../../commands/MorphCommand';
import WalkCommand from '../../commands/WalkCommand';

export default class TutorialLevel14 extends Tutorial {
	constructor(finger, panel, scene, commands) {
		super(finger, panel, scene, commands);
	}

	update() {
		super.update();
	}

	play() {
		super.play();

		if (this._destroyed) {
			return;
		}

		this.tweens.removeAll();
		this._scene.runButton.visible = true;

		let lastTween = null;

		if (this.stage === 0) {
			this._finger.rotation = 0;
			this._finger.scale.set(1);
			this._finger.alpha = 1;
			this._finger.position.set((common.STAGE_WIDTH - P3.View.width) * 0.5 + 300, 130);
			common.focusOverlay.setFocus(25, 65, 300, 85);

			this._commands.ui.add.interactive = false;
			this._panel.label.text = translate('GAME.TUTORIAL.STAGE14.SELECT_OVERFLOW');
			this.signals.update.dispatch();

			const t1 = new P3.utils.TWEEN.Tween(this._finger.scale, this.tweens)
				.to({x: 0.85, y: 0.85}, 300)
				.easing(P3.utils.Easing.Back2.Out)
				.yoyo(true)
				.repeat(1)
				.start();

			lastTween = new P3.utils.TWEEN.Tween(this._finger, this.tweens)
				.to({rotation: -15 * PIXI.DEG_TO_RAD}, 300)
				.easing(P3.utils.Easing.Back2.Out)
				.yoyo(true)
				.repeat(1)
				.start();

			t1.onComplete(() => {
				return lastTween.start();
			});
		} else if (this.stage === 1) {
			this._finger.rotation = 0;
			this._finger.scale.set(1, 1);
			this._finger.alpha = 1;
			this._finger.position.set((common.STAGE_WIDTH - P3.View.width) * 0.5 + 450, 130);
			common.focusOverlay.setFocus(25, 65, 450, 85);

			this._panel.label.text = translate('GAME.TUTORIAL.STAGE14.SELECT_OVERFLOW');
			this.signals.update.dispatch();

			if (this._commands.selector) {
				this._commands.selector.children[0].interactive = false;
				this._commands.selector.children[1].interactive = false;
			}

			const t1 = new P3.utils.TWEEN.Tween(this._finger.scale, this.tweens)
				.to({x: 0.85, y: 0.85}, 300)
				.easing(P3.utils.Easing.Back2.Out)
				.yoyo(true)
				.repeat(1)
				.start();

			lastTween = new P3.utils.TWEEN.Tween(this._finger, this.tweens)
				.to({rotation: -15 * PIXI.DEG_TO_RAD}, 300)
				.easing(P3.utils.Easing.Back2.Out)
				.yoyo(true)
				.repeat(1)
				.start();

			t1.onComplete(() => {
				return lastTween.start();
			});
		} else if (this.stage === 2) {
			this._finger.rotation = 0;
			this._finger.scale.set(1, 1);
			this._finger.alpha = 1;
			this._finger.position.set((common.STAGE_WIDTH * 0.5) + 100 - this._commands.ui.x, common.STAGE_HEIGHT - 210);
			common.focusOverlay.focusSprite(this._scene.runButton);

			this._panel.label.text = translate('GAME.TUTORIAL.STAGE14.RUN_CODE');
			this.signals.update.dispatch();

			this._commands.commands[1].interactive = false;
			this._commands.commands[1].canChangeVariable = false;

			const t1 = new P3.utils.TWEEN.Tween(this._finger.scale, this.tweens)
				.to({x: 0.85, y: 0.85}, 300)
				.easing(P3.utils.Easing.Back2.Out)
				.yoyo(true)
				.repeat(1)
				.start();

			lastTween = new P3.utils.TWEEN.Tween(this._finger, this.tweens)
				.to({rotation: -15 * PIXI.DEG_TO_RAD}, 300)
				.easing(P3.utils.Easing.Back2.Out)
				.yoyo(true)
				.repeat(1)
				.start();

			t1.onComplete(() => {
				return lastTween.start();
			});
		}

		if (lastTween) {
			lastTween.onComplete(() => {
				P3.utils.delayg(this.tweens, 0.5, () => {
					if (!this._destroyed) {
						this.play();
					}
				});
			});
		}
	}

	stop() {
		super.stop();
	}

	prepareCommands() {
		super.prepareCommands();

		for (let i = 0; i < 2; i++) {
			let command = null;
			if (i === 0) {
				command = new MorphCommand();
			} else if (i === 1) {
				command = new WalkCommand();
			}

			command.template = false;
			command.grabbable = false;
			command.locked = true;
			command.placed = true;
			this._commands.commandContainer.addChild(command);
			command.x = 169;
			command.setText(command.defaultVariable);
			command.variable = command.defaultVariable;

			for (const comm of this._commands.commands) {
				comm.slotPosition.set(comm.position.x, comm.position.y);
			}

			this._commands.commands.splice(i + 1, 0, command);
			this._commands.resize();

			command.signals.pickup.detachAll();

			if (i === 0) {
				command.interactive = true;
				command.canChangeVariable = true;
				command.signals.touch.add(this._commands.onCommandTouch, this._commands);
				command.signals.onVariableTouch.add(this._commands.onVariableTouch, this._commands);
			}

			if (i === 1) {
				command.variable = 6;
				command.defaultVariable = 6;
				command.setText(command.variable);
			}
		}
	}
}
